import { SESSIONS } from '../data/sessions';
import useReveal from './useReveal';
import Icon from './Icon';
import './Sessions.css'; // reuse .session-card visual language
import './SessionsTeaser.css';

const FEATURED_COUNT = 3;

export default function SessionsTeaser() {
  const gridRef = useReveal({ stagger: 80, maxStaggered: 3 });

  if (SESSIONS.length === 0) return null;

  const featured = SESSIONS.slice(0, FEATURED_COUNT);
  const totalPhotos = SESSIONS.reduce((n, s) => n + s.photos.length, 0);

  return (
    <section id="sessions" className="sessions sessions-teaser">
      <div className="container">
        <header className="sessions__header sessions-teaser__header">
          <div>
            <p className="eyebrow">In the field</p>
            <h2 className="sessions__title">Sessions delivered across workplaces &amp; campuses.</h2>
            <p className="sessions__sub">
              A glimpse of sessions conducted, with real teams, in real rooms.
            </p>
          </div>
          <a href="/sessions" className="btn btn-secondary sessions-teaser__cta sessions-teaser__cta--top">
            View all sessions
            <Icon name="arrow" size={16} className="sessions-teaser__cta-icon" />
          </a>
        </header>

        <div className="sessions__grid sessions-teaser__grid" ref={gridRef}>
          {featured.map((s) => (
            <a key={s.slug} href="/sessions" className="session-card" aria-label={`View ${s.title} in the sessions gallery`}>
              <span className="session-card__media">
                <img
                  className="session-card__img"
                  src={s.cover}
                  alt={`${s.title}${s.venue ? ` — ${s.venue}` : ''}`}
                  loading="lazy"
                  decoding="async"
                />
                <span className="session-card__scrim" aria-hidden="true" />
                <span className="session-card__tag">{s.categoryLabel}</span>
                <span className="session-card__count">
                  <Icon name="images" size={14} className="session-card__count-icon" />
                  Photos
                </span>
              </span>
              <span className="session-card__body">
                <span className="session-card__name">{s.title}</span>
                {(s.venue || s.date) && (
                  <span className="session-card__meta">
                    {s.venue && <Icon name="pin" size={14} className="session-card__meta-icon" />}
                    {[s.venue, s.date].filter(Boolean).join(' · ')}
                  </span>
                )}
              </span>
            </a>
          ))}
        </div>

        <a href="/sessions" className="btn btn-primary sessions-teaser__cta sessions-teaser__cta--bottom">
          View all {SESSIONS.length} sessions · {totalPhotos} photos
          <Icon name="arrow" size={16} className="sessions-teaser__cta-icon" />
        </a>
      </div>
    </section>
  );
}
